module.exports = __webpack_public_path__ + "img/contact.fbd58e89.png";